import dayjs from 'dayjs';

export class MockedVitodens200Features {
  mock(installationId: number, gatewaySerial: string) {
    return [
      {
        properties: {
          day: {
            type: 'array',
            value: [0.2, 0.6, 0.4, 0.3, 0.6, 0.4, 0.4, 0.4],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [
              0.8,
              3.1999999999999993,
              5.800000000000001,
              6.700000000000001,
              6.300000000000001,
              7.4,
              6.800000000000001,
              7.699999999999999,
            ],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [22.1, 31.5, 33.7, 34.4, 26.5, 11.2, 7.7, 4.7, 4.5, 4.4, 5.3, 22.4, 27.5],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [87.3, 219.8],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.power.consumption.heating',
        timestamp: '2023-03-28T07:49:18.454Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.forcedLastFromSchedule/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.forcedLastFromSchedule/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.forcedLastFromSchedule',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.forcedLastFromSchedule',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            unit: 'minute',
            value: 120,
            type: 'number',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time.offset',
        gatewayId: gatewaySerial,
        feature: 'heating.device.time.offset',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          timeAllStops: {
            type: 'number',
            value: 6076,
            unit: '',
          },
          timeLastStops: {
            type: 'number',
            value: 6076,
            unit: '',
          },
          flameLossDuringOperationAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          flameLossDuringOperationLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          temperatureMonitorAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          temperatureMonitorLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          stabilisationProcessAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          stabilisationProcessLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          ionizationAlignmentAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          ionizationAlignmentLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          undervoltageAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          undervoltageLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          safetyShutdownAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          safetyShutdownLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          temperatureMonitorIonizationComparisonAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          temperatureMonitorIonizationComparisonLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          safetyTimeAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          safetyTimeLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          flueGasTemperatureSensorAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          flueGasTemperatureSensorLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          noIonizationAtStartAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          noIonizationAtStartLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          noGasAtStartAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          noGasAtStartLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          noIgnitionAtStartAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          noIgnitionAtStartLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          safetyShutdownErrorShutdownAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          safetyShutdownErrorShutdownLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          normalStopAllStops: {
            type: 'number',
            value: 6,
            unit: '',
          },
          normalStopLastStops: {
            type: 'number',
            value: 6,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.timeseries.dhw.burner.stops',
        gatewayId: gatewaySerial,
        feature: 'device.timeseries.dhw.burner.stops',
        timestamp: '2023-03-28T07:04:07.436Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          defaultPressure: {
            unit: 'bar',
            value: 1.5,
            type: 'number',
          },
          normalPressureDelta: {
            unit: 'bar',
            value: 0.5,
            type: 'number',
          },
          maximumPressure: {
            unit: 'bar',
            value: 2.7,
            type: 'number',
          },
          errorThreshold: {
            unit: 'bar',
            value: 3.5,
            type: 'number',
          },
        },
        commands: {
          setNormalRange: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.pressure.total/commands/setNormalRange',
            name: 'setNormalRange',
            isExecutable: true,
            params: {
              defaultPressure: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.1,
                  max: 2.7,
                  stepping: 0.1,
                },
              },
              normalPressureDelta: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.1,
                  max: 1,
                  stepping: 0.1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.pressure.total',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.pressure.total',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [0.3, 0.6, 0.7, 0.7, 0.5, 0.7, 0.7, 0.6],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [
              0.8999999999999999,
              4.4,
              2.1999999999999997,
              1.4999999999999998,
              1.2,
              0.7,
              1.2999999999999998,
              1.3,
            ],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [11, 5.9, 7, 7.7, 6.9, 7.1, 6.5, 5.3, 7.1, 6.2, 7.5, 7.4, 8.9],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [24, 84.8],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.power.consumption.dhw',
        timestamp: '2023-03-28T08:49:19.562Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 70,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.pumps.internal.target',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.pumps.internal.target',
        timestamp: '2023-03-28T08:50:26.371Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.zigbee.status',
        gatewayId: gatewaySerial,
        feature: 'device.zigbee.status',
        timestamp: '2023-03-28T06:13:21.230Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.heating',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.zone.mode',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.zone.mode',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0.modulation',
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0.modulation',
        timestamp: '2023-03-28T08:50:53.684Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.multiFamilyHouse',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.multiFamilyHouse',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          enabled: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.hygiene/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          enable: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.hygiene/commands/enable',
            name: 'enable',
            isExecutable: true,
            params: {},
          },
          disable: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.hygiene/commands/disable',
            name: 'disable',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.hygiene',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.hygiene',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [48.1, 64, 42, 29, 69, 35, 35, 55],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [112.1, 340, 769.1, 940, 1030, 1104, 967, 1358.3],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [
              2882.1,
              4848.6,
              4941.9,
              5512.3,
              3688.8,
              951,
              554.5,
              122.1,
              127.2,
              114.2,
              225.2,
              2949.8,
              4434.9,
            ],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [12672.6, 31549.9],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heat.production.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.heat.production.heating',
        timestamp: '2023-03-28T08:39:22.459Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.status.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.status.raw',
        timestamp: '2023-03-28T06:13:21.229Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 32.8,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature.supply',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature.supply',
        timestamp: '2023-03-28T09:00:08.583Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.warnings.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.active',
        timestamp: '2023-03-27T17:01:44.260Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.modes.active/commands/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'heating'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.active',
        timestamp: '2023-03-28T06:13:23.179Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          hours: {
            type: 'number',
            value: 10814,
            unit: 'hour',
          },
          starts: {
            type: 'number',
            value: 33407,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0.statistics',
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0.statistics',
        timestamp: '2023-03-28T08:50:42.628Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 55,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTargetTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.main/commands/setTargetTemperature',
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  efficientLowerBorder: 10,
                  efficientUpperBorder: 60,
                  max: 60,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature.main',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature.main',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '7722311001902120',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.serial',
        gatewayId: gatewaySerial,
        feature: 'device.serial',
        timestamp: '2023-03-28T06:13:21.229Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 32.2,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors.temperature.supply',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors.temperature.supply',
        timestamp: '2023-03-28T09:01:01.278Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [1.3, 2.6, 3.1, 2.3, 3.9, 1.7, 1.3, 4],
            unit: 'cubicMeter',
          },
          week: {
            type: 'array',
            value: [
              3.9000000000000004,
              20.3,
              22.400000000000002,
              26.8,
              20,
              13.6,
              23.500000000000004,
              21.700000000000003,
            ],
            unit: 'cubicMeter',
          },
          month: {
            type: 'array',
            value: [88.1, 78.7, 95.5, 110.2, 94.4, 95.5, 85.8, 65.2, 94.4, 80.8, 102, 103.4, 126.7],
            unit: 'cubicMeter',
          },
          year: {
            type: 'array',
            value: [262.4, 1151.6],
            unit: 'cubicMeter',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.dhw',
        timestamp: '2023-03-28T08:20:31.462Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          countOne: {
            type: 'number',
            value: 2,
            unit: '',
          },
          timestampOne: {
            type: 'string',
            value: '2023-03-28T06:15:22.000Z',
          },
          countTwo: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampTwo: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countThree: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampThree: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countFour: {
            type: 'number',
            value: 6,
            unit: '',
          },
          timestampFour: {
            type: 'string',
            value: '2023-03-28T08:03:57.000Z',
          },
          countFive: {
            type: 'number',
            value: 2,
            unit: '',
          },
          timestampFive: {
            type: 'string',
            value: '2023-03-28T06:16:04.000Z',
          },
          countSix: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampSix: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countSeven: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampSeven: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countEight: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampEight: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countNine: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampNine: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countTen: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampTen: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.timeseries.ignitionTimeSteps',
        gatewayId: gatewaySerial,
        feature: 'device.timeseries.ignitionTimeSteps',
        timestamp: '2023-03-28T07:04:07.436Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 21,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.reduced/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.reduced',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.reduced',
        timestamp: '2023-03-28T06:13:23.250Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.lock.malfunction',
        gatewayId: gatewaySerial,
        feature: 'device.lock.malfunction',
        timestamp: '2023-03-28T08:50:39.407Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.service.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.service.active',
        timestamp: '2023-03-27T17:01:44.260Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.operating.modes.balanced',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.operating.modes.balanced',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [6.1, 12.5, 7.300000000000001, 5.199999999999999, 10.8, 5.2, 4.8, 9.5],
            unit: 'cubicMeter',
          },
          week: {
            type: 'array',
            value: [
              18.6,
              54.3,
              99.3,
              120.80000000000001,
              123.00000000000001,
              124.00000000000001,
              120.20000000000002,
              157.5,
            ],
            unit: 'cubicMeter',
          },
          month: {
            type: 'array',
            value: [
              376.29999999999995,
              563.5,
              589.6,
              661.4000000000001,
              463.20000000000005,
              190.6,
              141.2,
              77.4,
              107.10000000000001,
              92.2,
              124.5,
              398.29999999999995,
              570.1,
            ],
            unit: 'cubicMeter',
          },
          year: {
            type: 'array',
            value: [1529.6, 4306.5],
            unit: 'cubicMeter',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.total',
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.total',
        timestamp: '2023-03-28T08:50:33.862Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.heating',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [15, 20, 31, 23, 39, 17, 13, 40],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [35, 203, 224, 268, 200, 136, 235, 217],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [
              883.5,
              787.3,
              955.6,
              1102.8,
              944.5,
              955.4,
              858.3,
              652.9,
              944.4,
              808.2,
              1020.5,
              1034.8,
              1267.2,
            ],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [2626.5, 11516.8],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heat.production.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.heat.production.dhw',
        timestamp: '2023-03-28T08:49:24.876Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              tue: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              wed: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              thu: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              fri: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              sat: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              sun: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.heating.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal', 'comfort'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating.schedule',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating.schedule',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.frostprotection',
        timestamp: '2023-03-28T06:13:21.230Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 59.2,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.hotWaterStorage',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.hotWaterStorage',
        timestamp: '2023-03-28T08:54:59.721Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'liter',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.centralHeatingCylinderSize/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 6553.5,
                  stepping: 0.1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.centralHeatingCylinderSize',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.centralHeatingCylinderSize',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [
              {
                priority: 'criticalError',
                timestamp: '2023-03-28T10:49:57.000Z',
                accessLevel: 'customer',
                errorCode: 'F.370',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.errors.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.errors.raw',
        timestamp: '2023-03-28T08:50:41.775Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'unknown',
            type: 'string',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.reducedEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.reducedEnergySaving',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.summerEco',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.summerEco',
        timestamp: '2023-03-28T06:13:21.230Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: 'Grzejniki',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
            type: 'string',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.summerEco',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.summerEco',
        timestamp: '2023-03-28T06:13:21.230Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          profile: {
            value: 'none',
            type: 'string',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.screedDrying/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              profile: {
                type: 'string',
                required: true,
                constraints: {
                  enum: [
                    'profileOne',
                    'profileTwo',
                    'profileThree',
                    'profileFour',
                    'profileFive',
                    'profileSix',
                  ],
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.screedDrying/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.screedDrying',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.screedDrying',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'unknown',
            type: 'string',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.reducedEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.reducedEnergySaving',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.forcedLastFromSchedule/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.forcedLastFromSchedule/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.forcedLastFromSchedule',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.forcedLastFromSchedule',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [4.8, 9.9, 4.2, 2.9, 6.9, 3.5, 3.5, 5.5],
            unit: 'cubicMeter',
          },
          week: {
            type: 'array',
            value: [14.7, 34, 76.9, 94, 103, 110.40000000000002, 96.7, 135.79999999999998],
            unit: 'cubicMeter',
          },
          month: {
            type: 'array',
            value: [
              288.2,
              484.8,
              494.1,
              551.2,
              368.8,
              95.1,
              55.4,
              12.2,
              12.7,
              11.4,
              22.5,
              294.9,
              443.4,
            ],
            unit: 'cubicMeter',
          },
          year: {
            type: 'array',
            value: [1267.2, 3154.9],
            unit: 'cubicMeter',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.heating',
        timestamp: '2023-03-28T08:50:33.862Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 15,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 164.2,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 883.5,
            unit: 'kilowattHour',
          },
          lastMonth: {
            type: 'number',
            value: 787.3,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 2626.5,
            unit: 'kilowattHour',
          },
          lastYear: {
            type: 'number',
            value: 11516.8,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heat.production.summary.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.heat.production.summary.dhw',
        timestamp: '2023-03-28T08:49:24.876Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'EGas',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.gasType',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.gasType',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'array',
            value: [
              {
                busAddress: 1,
                busType: 'CanInternal',
                deviceObjectProperty: 'HMUMaster',
                deviceFunction: 'VitodensTwoHundred',
                softwareVersion: '0002.0515.2020.0456',
                hardwareVersion: '0002.0603.0102.0002',
                etn: '7470379006520121',
              },
              {
                busAddress: 50,
                busType: 'CanInternal',
                deviceObjectProperty: 'BCU',
                deviceFunction: 'No',
                softwareVersion: '0001.0519.2004.0136',
                hardwareVersion: '0001.0501.0200.0002',
                etn: '7632991026936126',
              },
              {
                busAddress: 60,
                busType: 'CanInternal',
                deviceObjectProperty: 'GasAirRatioSystem',
                deviceFunction: 'No',
                softwareVersion: '0000.0002.0002.0000',
                hardwareVersion: '0000.0000.0000.0000',
                etn: '0000000010532305',
              },
              {
                busAddress: 59,
                busType: 'CanInternal',
                deviceObjectProperty: 'HMI',
                deviceFunction: 'No',
                softwareVersion: '0003.0525.2016.0000',
                hardwareVersion: '0003.0503.0303.0002',
                etn: '7632562017559121',
              },
              {
                busAddress: 58,
                busType: 'CanInternal',
                deviceObjectProperty: 'BackendGateway',
                deviceFunction: 'Nothing',
                softwareVersion: '0019.0506.2244.0004',
                hardwareVersion: '0019.0001.0000.0000',
                etn: gatewaySerial,
              },
              {
                busAddress: 1,
                busType: 'PlusBus',
                deviceObjectProperty: 'ADIO',
                deviceFunction: 'MixerCircuitWithHydraulicSeparatorSensor',
                softwareVersion: '0005.0514.2004.0210',
                hardwareVersion: '65535.0001.0001.65535',
                etn: '7722517004705120',
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.busTopology',
        gatewayId: gatewaySerial,
        feature: 'device.busTopology',
        timestamp: '2023-03-28T06:13:21.232Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          latitude: {
            type: 'number',
            value: 0,
            unit: 'degree',
          },
          longitude: {
            type: 'number',
            value: 0,
            unit: 'degree',
          },
          altitude: {
            type: 'number',
            value: 0,
            unit: 'meter',
          },
        },
        commands: {
          setLocation: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.houseLocation/commands/setLocation',
            name: 'setLocation',
            isExecutable: true,
            params: {
              latitude: {
                required: true,
                constraints: {
                  min: -90,
                  max: 90,
                  stepping: 0.0001,
                },
                type: 'number',
              },
              longitude: {
                required: true,
                constraints: {
                  min: -180,
                  max: 180,
                  stepping: 0.0001,
                },
                type: 'number',
              },
              altitude: {
                required: true,
                constraints: {
                  min: 0,
                  max: 8848,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.houseLocation',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.houseLocation',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'on',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.circulation.pump',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.circulation.pump',
        timestamp: '2023-03-28T08:50:29.496Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.lock.external',
        gatewayId: gatewaySerial,
        feature: 'device.lock.external',
        timestamp: '2023-03-28T06:13:21.229Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          enabled: {
            type: 'array',
            value: ['0'],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners',
        gatewayId: gatewaySerial,
        feature: 'heating.burners',
        timestamp: '2023-03-28T06:13:21.230Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 'balanced',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.operating.modes.active/commands/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['balanced', 'off'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.operating.modes.active',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 23,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.normal/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.normal',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.normal',
        timestamp: '2023-03-28T06:13:23.246Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.oneTimeCharge/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.oneTimeCharge/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.oneTimeCharge',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.oneTimeCharge',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          status: {
            value: 'on',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.zone.mode',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.zone.mode',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          countOne: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampOne: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countTwo: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampTwo: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countThree: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampThree: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countFour: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampFour: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.timeseries.water.pressure.peaks',
        gatewayId: gatewaySerial,
        feature: 'device.timeseries.water.pressure.peaks',
        timestamp: '2023-03-28T06:13:21.229Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          value: {
            type: 'number',
            value: 36.6,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.flue.sensors.temperature.main',
        gatewayId: gatewaySerial,
        feature: 'heating.flue.sensors.temperature.main',
        timestamp: '2023-03-28T08:57:14.635Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.standby',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              tue: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              wed: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              thu: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              fri: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              sat: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              sun: [
                {
                  mode: 'comfort',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal', 'comfort'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.schedule',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.schedule',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 22,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.reduced/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.reduced',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.reduced',
        timestamp: '2023-03-28T06:13:23.249Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '',
            type: 'string',
          },
          end: {
            value: '',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/commands/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: true,
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/commands/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: true,
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/commands/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs.holiday',
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs.holiday',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.standby',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 24,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.normal/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.normal',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.normal',
        timestamp: '2023-03-28T06:13:23.245Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps.primary',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps.primary',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          timeAllStops: {
            type: 'number',
            value: 13650,
            unit: '',
          },
          timeLastStops: {
            type: 'number',
            value: 13650,
            unit: '',
          },
          flameLossDuringOperationAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          flameLossDuringOperationLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          temperatureMonitorAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          temperatureMonitorLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          stabilisationProcessAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          stabilisationProcessLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          ionizationAlignmentAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          ionizationAlignmentLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          undervoltageAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          undervoltageLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          safetyShutdownAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          safetyShutdownLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          temperatureMonitorIonizationComparisonAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          temperatureMonitorIonizationComparisonLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          safetyTimeAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          safetyTimeLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          flueGasTemperatureSensorAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          flueGasTemperatureSensorLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          noIonizationAtStartAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          noIonizationAtStartLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          noGasAtStartAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          noGasAtStartLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          noIgnitionAtStartAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          noIgnitionAtStartLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          safetyShutdownErrorShutdownAllStops: {
            type: 'number',
            value: 1,
            unit: '',
          },
          safetyShutdownErrorShutdownLastStops: {
            type: 'number',
            value: 1,
            unit: '',
          },
          normalStopAllStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
          normalStopLastStops: {
            type: 'number',
            value: 0,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.timeseries.burner.stops',
        gatewayId: gatewaySerial,
        feature: 'device.timeseries.burner.stops',
        timestamp: '2023-03-28T07:04:07.436Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [0.5, 1.2, 1.1, 1, 1.1, 1.1, 1.1, 1],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [
              1.7,
              7.6000000000000005,
              8,
              8.200000000000001,
              7.500000000000001,
              8.1,
              8.100000000000001,
              9,
            ],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [
              33.1,
              37.4,
              40.7,
              42.1,
              33.4,
              18.299999999999997,
              14.2,
              10,
              11.6,
              10.600000000000001,
              12.8,
              29.799999999999997,
              36.4,
            ],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [111.3, 304.6],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.total',
        gatewayId: gatewaySerial,
        feature: 'heating.power.consumption.total',
        timestamp: '2023-03-28T08:49:19.562Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          shift: {
            type: 'number',
            unit: '',
            value: 0,
          },
          slope: {
            type: 'number',
            unit: '',
            value: 1.4,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.3.heating.curve/commands/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.heating.curve',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.heating.curve',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [63.1, 84, 73, 52, 108, 52, 48, 95],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [147.1, 543, 993.1, 1208, 1230, 1240, 1202, 1575.3],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [
              3765.6,
              5635.9000000000015,
              5897.5,
              6615.1,
              4633.3,
              1906.4,
              1412.8,
              775,
              1071.6,
              922.4000000000001,
              1245.7,
              3984.6000000000004,
              5702.099999999999,
            ],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [15299.1, 43066.7],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heat.production.total',
        gatewayId: gatewaySerial,
        feature: 'heating.heat.production.total',
        timestamp: '2023-03-28T08:49:24.876Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'comfort',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.active',
        timestamp: '2023-03-28T06:13:21.232Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          position: {
            type: 'string',
            value: 'heating',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.valves.diverter.heatDhw',
        gatewayId: gatewaySerial,
        feature: 'heating.valves.diverter.heatDhw',
        timestamp: '2023-03-28T08:50:26.371Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [
                {
                  priority: 'criticalError',
                  timestamp: '2023-03-28T08:50:41.800Z',
                  accessLevel: 'customer',
                  errorCode: 'F.370',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
              ],
              current: [
                {
                  priority: 'criticalError',
                  timestamp: '2023-03-28T08:50:41.800Z',
                  accessLevel: 'customer',
                  errorCode: 'F.370',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
              ],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors.active',
        gatewayId: gatewaySerial,
        feature: 'heating.errors.active',
        timestamp: '2023-03-28T08:50:41.793Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'on',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.pumps.internal',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.pumps.internal',
        timestamp: '2023-03-28T06:13:21.230Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.status.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.status.active',
        timestamp: '2023-03-27T17:01:44.260Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.warnings.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.raw',
        timestamp: '2023-03-28T06:13:21.229Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.zone.mode',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.zone.mode',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 25,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.comfort',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.comfort',
        timestamp: '2023-03-28T06:13:23.236Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 'individual',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.schedule.mode/commands/setMode',
            name: 'setMode',
            isExecutable: false,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['individual'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.schedule.mode',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.schedule.mode',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 57.7,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.temperature.current',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.temperature.current',
        timestamp: '2023-03-28T08:59:41.279Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0.2,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 3.3,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 22.1,
            unit: 'kilowattHour',
          },
          lastMonth: {
            type: 'number',
            value: 31.5,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 87.3,
            unit: 'kilowattHour',
          },
          lastYear: {
            type: 'number',
            value: 219.8,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.summary.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.power.consumption.summary.heating',
        timestamp: '2023-03-28T08:34:19.928Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'on',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.circulation.pump',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.circulation.pump',
        timestamp: '2023-03-28T08:50:29.496Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.standby',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 33.1,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors.temperature.commonSupply',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors.temperature.commonSupply',
        timestamp: '2023-03-28T08:59:12.813Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.summerEco',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.summerEco',
        timestamp: '2023-03-28T06:13:21.230Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 2.7,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.outside',
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.outside',
        timestamp: '2023-03-28T08:49:41.267Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'unknown',
            type: 'string',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.operating.programs.reducedEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.operating.programs.reducedEnergySaving',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.info.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.info.raw',
        timestamp: '2023-03-28T06:13:21.229Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0',
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0',
        timestamp: '2023-03-28T08:50:53.684Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 48.1,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 357.4,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 2882.1,
            unit: 'kilowattHour',
          },
          lastMonth: {
            type: 'number',
            value: 4848.6,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 12672.6,
            unit: 'kilowattHour',
          },
          lastYear: {
            type: 'number',
            value: 31549.9,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heat.production.summary.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.heat.production.summary.heating',
        timestamp: '2023-03-28T08:39:22.459Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          shift: {
            type: 'number',
            unit: '',
            value: 3,
          },
          slope: {
            type: 'number',
            unit: '',
            value: 0.6,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.heating.curve/commands/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating.curve',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating.curve',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          countOne: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampOne: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countTwo: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampTwo: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countThree: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampThree: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countFour: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampFour: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countFive: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampFive: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countSix: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampSix: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
          countSeven: {
            type: 'number',
            value: 0,
            unit: '',
          },
          timestampSeven: {
            type: 'string',
            value: '1970-01-01T00:00:00.000Z',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.timeseries.monitoringIonization',
        gatewayId: gatewaySerial,
        feature: 'device.timeseries.monitoringIonization',
        timestamp: '2023-03-28T06:13:21.229Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          shift: {
            type: 'number',
            unit: '',
            value: 0,
          },
          slope: {
            type: 'number',
            unit: '',
            value: 1.4,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.heating.curve/commands/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.heating.curve',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.heating.curve',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'liter',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.dhwCylinderSize/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 6553.5,
                  stepping: 0.1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.dhwCylinderSize',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.dhwCylinderSize',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.frostprotection',
        timestamp: '2023-03-28T06:13:21.230Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.outlet',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.outlet',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.info.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.info.active',
        timestamp: '2023-03-27T17:01:44.260Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'comfort',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.active',
        timestamp: '2023-03-28T06:13:21.232Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          shift: {
            type: 'number',
            unit: '',
            value: 3,
          },
          slope: {
            type: 'number',
            unit: '',
            value: 1.1,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.curve/commands/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.curve',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.curve',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.standby',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 4.8,
            unit: 'cubicMeter',
          },
          lastSevenDays: {
            type: 'number',
            value: 35.7,
            unit: 'cubicMeter',
          },
          currentMonth: {
            type: 'number',
            value: 288.2,
            unit: 'cubicMeter',
          },
          lastMonth: {
            type: 'number',
            value: 484.8,
            unit: 'cubicMeter',
          },
          currentYear: {
            type: 'number',
            value: 1267.2,
            unit: 'cubicMeter',
          },
          lastYear: {
            type: 'number',
            value: 3154.9,
            unit: 'cubicMeter',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.summary.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.summary.heating',
        timestamp: '2023-03-28T08:50:33.862Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            unit: 'bar',
            value: 1.8,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.pressure.supply',
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.pressure.supply',
        timestamp: '2023-03-28T08:57:46.642Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          mode: {
            value: 'WeatherByOutsideSensorControlled',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.regulation',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.regulation',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 1.3,
            unit: 'cubicMeter',
          },
          lastSevenDays: {
            type: 'number',
            value: 16.2,
            unit: 'cubicMeter',
          },
          currentMonth: {
            type: 'number',
            value: 88.1,
            unit: 'cubicMeter',
          },
          lastMonth: {
            type: 'number',
            value: 78.7,
            unit: 'cubicMeter',
          },
          currentYear: {
            type: 'number',
            value: 262.4,
            unit: 'cubicMeter',
          },
          lastYear: {
            type: 'number',
            value: 1151.6,
            unit: 'cubicMeter',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.summary.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.summary.dhw',
        timestamp: '2023-03-28T08:20:31.462Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '7722311001902120',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.serial',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.serial',
        timestamp: '2023-03-28T06:13:21.232Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          profile: {
            value: 'none',
            type: 'string',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.screedDrying/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              profile: {
                type: 'string',
                required: true,
                constraints: {
                  enum: [
                    'profileOne',
                    'profileTwo',
                    'profileThree',
                    'profileFour',
                    'profileFive',
                    'profileSix',
                  ],
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.screedDrying/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.screedDrying',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.screedDrying',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '',
            type: 'string',
          },
          end: {
            value: '',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holidayAtHome/commands/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: true,
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holidayAtHome/commands/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: true,
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holidayAtHome/commands/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs.holidayAtHome',
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs.holidayAtHome',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [48.1, 64, 42, 29, 69, 35, 35, 55],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [112.1, 340, 769.1, 940, 1030, 1104, 967, 1358.3],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [
              2882.1,
              4848.6,
              4941.9,
              5512.3,
              3688.8,
              951,
              554.5,
              122.1,
              127.2,
              114.2,
              225.2,
              2949.8,
              4434.9,
            ],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [12672.6, 31549.9],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heat.production',
        gatewayId: gatewaySerial,
        feature: 'heating.heat.production',
        timestamp: '2023-03-28T08:39:22.459Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: 'Podłoga',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
            type: 'string',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          enabled: {
            value: ['0', '1'],
            type: 'array',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0.3,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 4.4,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 11,
            unit: 'kilowattHour',
          },
          lastMonth: {
            type: 'number',
            value: 5.9,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 24,
            unit: 'kilowattHour',
          },
          lastYear: {
            type: 'number',
            value: 84.8,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.summary.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.power.consumption.summary.dhw',
        timestamp: '2023-03-28T08:49:19.562Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'on',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              tue: [
                {
                  mode: 'on',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              wed: [
                {
                  mode: 'on',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              thu: [
                {
                  mode: 'on',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              fri: [
                {
                  mode: 'on',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              sat: [
                {
                  mode: 'on',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
              sun: [
                {
                  mode: 'on',
                  start: '00:00',
                  end: '24:00',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['on'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'off',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.schedule',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.schedule',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour/year',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.houseHeatingLoad/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 65531,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.houseHeatingLoad',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.houseHeatingLoad',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.operating.programs.summerEco',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.operating.programs.summerEco',
        timestamp: '2023-03-28T06:13:21.230Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 300,
            unit: 'liter',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.bufferCylinderSize/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 6553.5,
                  stepping: 0.1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.bufferCylinderSize',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.bufferCylinderSize',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          demand: {
            value: 'unknown',
            type: 'string',
          },
          temperature: {
            value: 25,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfort/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfort/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfort/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.comfort',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.comfort',
        timestamp: '2023-03-28T06:13:23.236Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          horizontal: {
            type: 'number',
            value: 0,
            unit: 'degree',
          },
          vertical: {
            type: 'number',
            value: 0,
            unit: 'degree',
          },
        },
        commands: {
          setOrientation: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.houseOrientation/commands/setOrientation',
            name: 'setOrientation',
            isExecutable: true,
            params: {
              horizontal: {
                required: true,
                constraints: {
                  min: 0,
                  max: 360,
                  stepping: 1,
                },
                type: 'number',
              },
              vertical: {
                required: true,
                constraints: {
                  min: 0,
                  max: 360,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.houseOrientation',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.houseOrientation',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.zone.mode',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.zone.mode',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'unknown',
            type: 'string',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.reducedEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.reducedEnergySaving',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.modes.active/commands/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'heating'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.active',
        timestamp: '2023-03-28T06:13:23.164Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/device.zigbee.active/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/device.zigbee.active/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.zigbee.active',
        gatewayId: gatewaySerial,
        feature: 'device.zigbee.active',
        timestamp: '2023-03-27T19:03:59.808Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '7470379006520121',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.etn',
        gatewayId: gatewaySerial,
        feature: 'device.etn',
        timestamp: '2023-03-28T06:13:21.229Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 20,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.temperature',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.temperature',
        timestamp: '2023-03-28T06:13:21.230Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.service.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.service.raw',
        timestamp: '2023-03-28T06:13:21.229Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.operating.modes.off',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.operating.modes.off',
        timestamp: '2023-03-28T06:13:21.231Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.geofencing',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.geofencing',
        deviceId: '0',
        timestamp: '2023-03-26T06:37:15.724Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2023-03-27T19:03:59.808Z',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.name',
        feature: 'heating.circuits.0.name',
        deviceId: '0',
        gatewayId: gatewaySerial,
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.name/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        properties: {
          name: {
            type: 'string',
            value: 'Grzejniki',
          },
        },
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.geofencing',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.geofencing',
        deviceId: '0',
        timestamp: '2023-03-26T06:37:15.728Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2023-03-27T19:03:59.808Z',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.name',
        feature: 'heating.circuits.1.name',
        deviceId: '0',
        gatewayId: gatewaySerial,
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.name/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        properties: {
          name: {
            type: 'string',
            value: 'Podłoga',
          },
        },
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.geofencing',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.geofencing',
        deviceId: '0',
        timestamp: '2023-03-26T06:37:15.724Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.geofencing',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.geofencing',
        deviceId: '0',
        timestamp: '2023-03-26T06:37:15.724Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
      },
    ];
  }
}
